import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';

import { IndexTickerComponent } from './index-ticker.component';
import { IndexWatchDialogComponent } from './index-watch-dialog/index-watch-dialog.component';
import { LocaleConverterModule, NullCheckModule, PercentPipeModule } from '@app/_shared/pipes';

@NgModule({
    declarations: [
        IndexTickerComponent,
        IndexWatchDialogComponent
    ],
    imports: [
        CommonModule,
        DragDropModule,
        MatMenuModule,
        MatButtonModule,
        MatIconModule,
        MatDialogModule,
        LocaleConverterModule,
        NullCheckModule,
        PercentPipeModule
    ],
    exports: [
        IndexTickerComponent
    ]
})
export class IndexTickerModule { }

